import { Resend } from 'resend';

const resend = new Resend('re_7oFUPkmV_Mz3px83RPnBjA6K9Z95ZVAhM');

export const resendService = {
  async sendInvitation(
    to: string,
    projectName: string,
    projectLink: string,
    inviterName: string,
    guestPassword: string
  ): Promise<void> {
    try {
      await resend.emails.send({
        from: 'FeedbackFlow <notifications@minidev.pro>',
        to: [to],
        subject: `${inviterName} invited you to collaborate on ${projectName}`,
        html: `
          <div>
            <h2>You've been invited to collaborate!</h2>
            <p>${inviterName} has invited you to collaborate on ${projectName}.</p>
            <p>Use this password to access the project: <strong>${guestPassword}</strong></p>
            <p>
              <a href="${projectLink}" style="background-color: #4F46E5; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px; display: inline-block;">
                View Project
              </a>
            </p>
          </div>
        `
      });
    } catch (error) {
      console.error('Error sending invitation email:', error);
      throw new Error('Failed to send invitation email');
    }
  },

  async sendWelcomeEmail(to: string, firstName: string): Promise<void> {
    try {
      await resend.emails.send({
        from: 'FeedbackFlow <welcome@minidev.pro>',
        to: [to],
        subject: 'Welcome to FeedbackFlow!',
        html: `
          <div>
            <h2>Welcome to FeedbackFlow, ${firstName}!</h2>
            <p>We're excited to have you on board. Here's what you can do next:</p>
            <ul>
              <li>Create your first project</li>
              <li>Invite team members</li>
              <li>Start collecting feedback</li>
            </ul>
            <p>
              <a href="${window.location.origin}/?mode=dashboard" style="background-color: #4F46E5; color: white; padding: 10px 20px; text-decoration: none; border-radius: 5px; display: inline-block;">
                Go to Dashboard
              </a>
            </p>
          </div>
        `
      });
    } catch (error) {
      console.error('Error sending welcome email:', error);
      throw new Error('Failed to send welcome email');
    }
  },

  async sendPasswordResetEmail(to: string, resetLink: string): Promise<void> {
    try {
      await resend.emails.send({
        from: 'FeedbackFlow <security@minidev.pro>',
        to: [to],
        subject: 'Password Changed - FeedbackFlow',
        html: `
          <h1>Password Changed</h1>
      <p>Your password for FeedbackFlow account (${email}) has been changed.</p>
      <p>If you did not make this change, please contact support immediately at support@minidev.pro</p>
    
        `
      });
    } catch (error) {
      console.error('Error sending password reset email:', error);
      throw new Error('Failed to send password reset email');
    }
  }
};